import { isEmpty, isNil, trim } from 'lodash';

export function pluralize(count: number, word: string, suffix = 's') {
  return `${word}${count !== 1 ? suffix : ''}`;
}

export function isNullOrWhitespace(value?: string | null): value is null | undefined | '' {
  if (isNil(value)) return true;

  return value.trim().length === 0;
}

/**
 * Converts an empty or whitespace-only string, null, or undefined value to undefined.
 * If the input is a non-empty string, it trims the value and returns it.
 *
 * @param value - The input value to process.
 * @return The trimmed string if non-empty, otherwise undefined.
 */
export function emptyToUndefined(value: string | null | undefined) {
  const trimmed = trim(value ?? '');
  return isEmpty(trimmed) ? undefined : trimmed;
}
